import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import unmatchOptionsActions from '../unmatchOptions/actions';
import { loadData } from '../unmatchOptions/saga';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';
import Api from '../../../helpers/api';
import { keyByProperty } from '../../../helpers/core';
import { t } from '../../../i18n';

const api = new Api('unmatched_reasons/:id');
const api2 = new Api('unmatched_reasons');

function* save(data) {
  try {
    const { payload } = data;
    const { editForm, id } = payload;

    const propsArray = Object.values(editForm);
    const unmatchedOption = keyByProperty(propsArray, 'name', prop => prop.value);

    const result = yield call(
      sendRequest,
      api.updateItem,
      {
        data: {
          unmatched_reason: {
            name: unmatchedOption.name,
            order: unmatchedOption.order,
            image: unmatchedOption.image,
            selected_image: unmatchedOption.selected_image,
          },
        },
        id,
      },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      if (result.data) {
        yield put(unmatchOptionsActions.closeModal());
        yield loadData();
        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: t('dash.common.notification.updated_successfully', {
              item: t('dash.admin.editUnmatchedOption.unmached_option'),
            }),
          }),
        );
      } else {
        yield put(actions.saveError({ data: result }));
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* add(data) {
  try {
    const { payload } = data;
    const { editForm } = payload;

    const propsArray = Object.values(editForm);
    const unmatchedOption = keyByProperty(propsArray, 'name', prop => prop.value);

    const result = yield call(
      sendRequest,
      api2.createItem,
      {
        data: {
          unmatched_reason: {
            name: unmatchedOption.name,
            order: unmatchedOption.order,
            image: unmatchedOption.image,
            selected_image: unmatchedOption.selected_image,
          },
        },
      },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      if (result.data) {
        yield put(unmatchOptionsActions.closeModal());
        yield loadData();
        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: t('dash.common.notification.created_successfully', {
              item: t('dash.admin.editUnmatchedOption.unmached_option'),
            }),
          }),
        );
      } else {
        yield put(actions.saveError({ data: result }));
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

export { save, add };
export default function* rootSaga() {
  yield all([takeEvery(actions.SAVE, save), takeEvery(actions.ADD, add)]);
}
